import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';
import { Model } from '../../types/response';

export interface ModelSliceInterface {
    value : Model| null;
}

const initialState: ModelSliceInterface = {
    value : null
}

export const modelSlice = createSlice({
    name : 'modelResponse',
    initialState,
    reducers: {
        set: (state, action : PayloadAction<ModelSliceInterface>) => {
            state.value = action.payload.value;
        }
    }
});

export const { set } = modelSlice.actions;

export default modelSlice.reducer;
